<div id="charts-page" *ngIf="pageReady">
  <ng-container *ngIf="chartId !== ''; else emptyChartBlock">
    <div class="chart-ops-holder">
      <div *ngIf="!metaReady" style="width: 465px">
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </div>

      <ng-container *ngIf="metaReady">
        <app-edit-name-input
          [chartName]="chartsMeta.chartName"
          [isEditable]="chartId !== 'suggested' && chartId !== 'current'"
          (onChange)="onChartNameChange($event)"
          (saveAsCustom)="onChangeSuggestedChartName($event)"
        ></app-edit-name-input>
        <div class="chart-ops">
          <app-global-user-settings-button
            [disabled]="!metaReady"
            class="mr-12"
          ></app-global-user-settings-button>

          <button
            class="va-button va-icon-button va-button-outline va-button-outline--primary mr-12"
            (click)="saveToCustomChartAction()"
            *ngIf="chartId === 'suggested' || chartId === 'current'"
            [ngClass]="[!metaReady ? 'va-button--disabled' : '']"
            title="Save to Custom Charts"
          >
            <va-icon size="small" name="save" class="va-button-icon"></va-icon>
          </button>

          <button
            *ngIf="chartId !== 'suggested' && chartId !== 'current'"
            class="va-button va-icon-button va-button-outline va-button-outline--primary mr-12"
            [ngClass]="[
              isShareChartModalVisible ? 'va-button--active' : '',
              !metaReady ? 'va-button--disabled' : ''
            ]"
            (click)="shareChart()"
            title="Share"
          >
            <va-icon
              [isFontAwesome]="true"
              [name]="faShare"
              class="va-button-icon"
            ></va-icon>
          </button>

          <!-- Download button -->
          <button
            class="va-button va-icon-button va-button-outline va-button-outline--primary mr-12"
            [ngClass]="[
              !metaReady || !chartInstance ? 'va-button--disabled' : '',
              downloadOptVisible ? 'va-button--active' : ''
            ]"
            nz-popover
            nzPopoverTrigger="click"
            [nzPopoverContent]="downloadOptionsTemplate"
            [nzPopoverPlacement]="
              chartId === 'suggested' || chartId === 'current'
                ? 'bottomRight'
                : 'bottom'
            "
            [(nzPopoverVisible)]="downloadOptVisible"
            nzOverlayClassName="chart-download-popover"
            title="Download"
          >
            <va-icon
              *ngIf="!loadingDocuments; else chartLoading"
              size="small"
              name="arrow-to-bottom"
              class="va-button-icon"
            ></va-icon>
          </button>

          <!-- Download options template -->
          <ng-template #downloadOptionsTemplate>
            <div class="download-opt" (click)="downloadValue(4)">
              Print Chart
            </div>
            <hr class="solid" />
            <div (click)="downloadValue(0)" class="download-opt">
              Download PNG
            </div>
            <div (click)="downloadValue(1)" class="download-opt">
              Download JPEG
            </div>
            <div (click)="downloadValue(2)" class="download-opt">
              Download PDF
            </div>
            <div (click)="downloadValue(3)" class="download-opt">
              Download SVG
            </div>
            <hr class="solid" />
            <div (click)="onExport()" class="download-opt">Export Value</div>
          </ng-template>

          <!-- Download loading template -->
          <ng-template #chartLoading>
            <div>
              <ng-template #indicatorTemplate>
                <va-icon
                  name="fasSpinner"
                  isFontAwesome="true"
                  [spin]="true"
                  class="va-button-icon"
                ></va-icon>
              </ng-template>
              <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
            </div>
          </ng-template>

          <!-- Delete button-->
          <button
            (click)="showDeleteAlertModal()"
            class="va-button va-icon-button va-button-outline va-button-outline--danger"
            title="Click to delete Chart"
            *ngIf="chartId !== 'suggested' && chartId !== 'current'"
            [ngClass]="[
              isDeleteAlertModalVisible ? 'va-button--active' : '',
              !metaReady ? 'va-button--disabled' : ''
            ]"
          >
            <va-icon size="small" name="trash" class="va-button-icon"></va-icon>
          </button>
        </div>
      </ng-container>
    </div>
    <div class="charts-filters">
      <div class="on-screen-filter-wrapper">
        <div class="onscr-ticker mr-24" *ngIf="metaReady; else loader">
          <label class="filter-label">Tickers</label>
          <app-ticker-search
            [tickers]="rowTickers"
            [onScreen]="true"
            [isComp]="true"
            (onSearchedTickerUpdate)="onSearchTickerSelection($event)"
            [hasSearchIcon]="true"
            [disabled]="!(tickerModalDataReady && metaReady)"
            placeholder="&nbsp;Add Tickers"
            [suggestedTickers]="peerCompanies"
            maxSelectedTickerCount="10"
          ></app-ticker-search>
          <button
            nz-button
            class="on-screen-search__edit-btn"
            (click)="showEditTickersModal()"
            [ngClass]="{
              'on-screen-search__edit-btn--active': isVisibleEditTickerModal
            }"
            [disabled]="!(tickerModalDataReady && metaReady)"
          >
            Edit
          </button>
        </div>
        <div class="onscr-ticker mr-24" *ngIf="metaReady; else loader">
          <app-lineitem-filter
            [options]="stdLineItems"
            [selectedValue]="{}"
            [selectedOptionsId]="selectedLiId"
            liFilterId="chartsPageLI"
            [bottomBorderView]="true"
            [disabled]="!(leftModalDataReady && metaReady)"
            label="Line Items"
            [showButton]="true"
            (onValueChange)="onSearchedLi($event)"
            (onEditButtonClick)="showEditLiModal()"
          ></app-lineitem-filter>
        </div>
        <app-charts-filters
          (onCurrencyFilterChange)="updateCurrency($event)"
          (setPeriod)="updateRevisionPeriod($event)"
          (onEstimatesFilterChange)="updateEstimates($event)"
          (onScaleTypeFilterChange)="updateScaleType($event)"
          (onDataViewFilterChange)="updateDataView($event)"
          (onRevisionFilterChange)="updateRevision($event)"
          (saveYearType)="updateYearType($event)"
          [filterData]="filterData"
          [chartTypeId]="chartTypeId"
          [metaReady]="metaReady"
          [periodsWithAvailableData]="periodsWithAvailableData"
        ></app-charts-filters>
      </div>
      <div class="button-container">
        <!-- <button
          nz-button
          class="button"
          (click)="showEditTickersModal()"
          [ngClass]="tickerModalDataReady && metaReady ? 'btn' : ''"
          [disabled]="!(tickerModalDataReady && metaReady)"
        >
          Edit Tickers
        </button> -->
        <!-- <button
          nz-button
          class="button"
          (click)="showEditLiModal()"
          [disabled]="!(leftModalDataReady && metaReady)"
          style="margin-right: 0px;"
          [ngClass]="leftModalDataReady && metaReady ? 'btn' : ''"
        >
          Edit Line Items
        </button> -->
      </div>
    </div>
    <app-charts-plotter-container
      [selectedChart]="selectedChart"
      [chartFilters]="selectedFilters"
      (onChartInstance)="onChartInstance($event)"
    >
    </app-charts-plotter-container>
    <div *ngIf="factsetDataAccess" class="factset_copyright_footnote">
      {{ factsetCopyRightMessage }}
    </div>
  </ng-container>

  <ng-template #emptyChartBlock>
    <div class="empty-chart-template">
      <p>You have not created any custom Charts.</p>
      <p>
        Click
        <button
          nz-button
          (click)="createNewChart()"
          [ngClass]="tickerModalDataReady ? 'create-btn' : ''"
          style="margin-right: 0px"
          [disabled]="!tickerModalDataReady"
        >
          Create Chart
        </button>
        to create your first one, or view pre-built charts on the left panel.
      </p>
    </div>
  </ng-template>

  <ng-template #loader>
    <div *ngIf="!tickerModalDataReady" class="on-screen-search__loader mr-24">
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </div>
  </ng-template>
</div>

<app-charts-ticker-modal
  *ngIf="pageReady"
  [(modalVisible)]="isVisibleEditTickerModal"
  (onClose)="onCloseEditTickersModal($event)"
  [addRowTableData]="addRowTableData"
  [(watchlists)]="watchlistData"
  [recentlyVisitedCompanies]="recentlyVisitedCompanies"
  [peerCompanies]="peerCompanies"
  [mpt]="mpt"
  [maxHeight]="'320px'"
  [max]="10"
  (onTickerUpdate)="updateChartTickers($event)"
></app-charts-ticker-modal>

<app-charts-li-modal
  *ngIf="pageReady"
  [(modalVisible)]="isVisibleEditLiModal"
  (onClose)="onCloseEditLiModal($event)"
  [addColTableData]="addColTableData"
  [selectedPeriod]="
    selectedFilters && selectedFilters.periods && selectedFilters.otherPeriods
      ? selectedFilters.periods.concat(selectedFilters.otherPeriods)
      : undefined
  "
  [stdLineItems]="stdLineItems"
  [maxHeight]="'300px'"
  [tickers]="rowTickers"
  [max]="2"
  (onLiUpdate)="updateChartLI($event)"
></app-charts-li-modal>

<ng-template #successTemplate>
  <div class="snackbar-content">
    <va-icon name="check" class="snack-icon snack-success-icon"></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #failureTemplate>
  <div class="snackbar-content">
    <va-icon name="close-circle" class="snack-icon snack-failure-icon"></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #infoTemplate>
  <div class="snackbar-content">
    <va-icon name="info-circle" class="snack-icon snack-info-icon"></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
